// extracted by mini-css-extract-plugin
export var active = "_js-2";
export var recordingDot = "_js-1";
export var recordingIndicator = "_js-0";